<template>
  <a  
    href="#"
    class="btn btn-cta"
    @click.prevent="(e) => emit('click', e)"
  >
    {{ $t("lot.preempt") }}
  </a>
</template>

<script setup>

const props = defineProps({
  auction: {
    type: Object,
    required: true
  },
  lot: {
    type: Object,
    required: true
  },
})

const emit = defineEmits(['click'])

</script>